module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "p-t-md p-b-md inner-content"
  }, [_vm._v("\n  " + _vm._s( /** 订单类别 */ ) + "\n  "), _c('div', {
    staticClass: "bg-gray-5 p-a"
  }, [_vm._v("\n    我的订单：\n    "), _vm._l((_vm.types), function(t, index) {
    return _c('span', {
      class: {
        'order-list-type': true,
        'active': index === _vm.activeType
      },
      on: {
        "click": function($event) {
          return _vm.changeActiveType(index)
        }
      }
    }, [_vm._v(_vm._s(t))])
  })], 2), _vm._v("\n  " + _vm._s( /** 订单列表 */ ) + "\n  "), _vm._l((_vm.orders), function(o) {
    return _c('div', {
      staticClass: "order-item"
    }, [_c('div', {
      staticClass: "order-header"
    }, [_vm._v("\n      订单编号：" + _vm._s(o.orderNo) + " "), _c('span', {
      staticClass: "m-l-lg"
    }, [_vm._v("下单时间：" + _vm._s(o.createdTime))])]), _vm._v(" "), _c('div', {
      staticClass: "bg-white clearfix o-item-wrp"
    }, [_c('div', {
      staticClass: "o-3-1 p-a-20"
    }, [_c('img', {
      staticClass: "o-img pull-left",
      attrs: {
        "src": o.caseInfo && o.caseInfo.coverImgUrl
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "o-info"
    }, [_c('div', {
      staticClass: "o-header text-elli"
    }, [_vm._v(_vm._s(o.caseInfo && o.caseInfo.title))]), _vm._v(" "), _c('div', {
      staticClass: "o-desc text-elli"
    }, [_vm._v(_vm._s(o.caseInfo && o.caseInfo.description))])])]), _vm._v(" "), _c('div', {
      staticClass: "o-3-1 p-a-20 text-center o-price-wrp"
    }, [_vm._v("\n        定金："), _c('span', {
      staticClass: "text-price"
    }, [_vm._v("￥" + _vm._s(o.price / 100 || ''))])]), _vm._v(" "), _c('div', {
      staticClass: "o-3-1 p-a-20 text-right"
    }, [(!o.isRefund && (o.refund === 0 || o.refund === 3)) ? _c('div', {
      staticStyle: {
        "height": "40px"
      }
    }, [(o.status === 1 || o.status === 2) ? _c('button', {
      staticClass: "c-b c-b-refund",
      on: {
        "click": function($event) {
          return _vm.applyRefund(o)
        }
      }
    }, [_vm._v("申请退款")]) : _vm._e()]) : _vm._e(), _vm._v(" "), (!o.isRefund && o.refund === 0 || (o.refund === 3 && o.status === 2) && !(o.refund === 1 && o.status === 2) && o.refundStatus !== 1) ? _c('div', {
      staticClass: "m-t-20 text-medium"
    }, [_vm._v("订单状态：" + _vm._s(_vm.orderStatus[o.status]))]) : _vm._e(), _vm._v(" "), (o.refund !== 0 && !(o.refund === 3 && o.status === 2)) ? _c('div', {
      staticClass: "m-t-20 text-medium"
    }, [_vm._v("订单状态：" + _vm._s(_vm.refundStatus[o.refund]))]) : _vm._e(), _vm._v(" "), (o.refundStatus === 1) ? _c('div', {
      staticClass: "m-t-20 text-medium"
    }, [_vm._v("订单状态：退款中")]) : _vm._e()])])])
  }), _vm._v(" "), (_vm.showHint) ? _c('div', {
    staticClass: "hint"
  }, [_vm._v(_vm._s(_vm.hintMsg))]) : _vm._e(), _vm._v("\n  " + _vm._s( /** 分页 */ ) + "\n  "), _c('pagination', {
    attrs: {
      "pagination": _vm.pagination,
      "callback": _vm.loadData,
      "options": _vm.paginationOptions
    }
  })], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3966756a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/OrderList.vue
// module id = 601
// module chunks = 1